import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0F1927] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 pl-8 py-1.5 flex items-center justify-between">
        <a href="/" className="flex items-center ml-4">
          <img
            src="https://static.readdy.ai/image/c49b0ef96301e9c0c6cb71cd7a692584/b7869fd43b50976bd57316695360829f.png"
            alt="Strive Claims"
            className="h-16 md:h-[100px] w-auto object-contain"
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'Services', id: 'services' },
            { label: 'How It Works', id: 'how-it-works' },
            { label: 'Why Us', id: 'why-us' },
            { label: 'Contact', id: 'booking' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white text-sm font-medium hover:text-[#5BA8E5] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:+18132857094"
            className="text-[#5BA8E5] font-semibold text-sm whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-phone-fill" />
            (813) 285-7094
          </a>
          <button
            onClick={() => scrollTo('booking')}
            className="bg-[#1B78D4] hover:bg-[#1464BB] text-white font-bold text-sm px-6 py-3 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer shadow-[0_4px_16px_rgba(27,120,212,0.35)] hover:shadow-[0_4px_24px_rgba(27,120,212,0.5)]"
          >
            Book Free Inspection
          </button>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-white text-2xl cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-[#0F1927] border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {[
            { label: 'Services', id: 'services' },
            { label: 'How It Works', id: 'how-it-works' },
            { label: 'Why Us', id: 'why-us' },
            { label: 'Contact', id: 'booking' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white text-left text-sm font-medium hover:text-[#5BA8E5] transition-colors cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <a href="tel:+18132857094" className="text-[#5BA8E5] font-semibold text-sm flex items-center gap-2">
            <i className="ri-phone-fill" /> (813) 285-7094
          </a>
          <button
            onClick={() => scrollTo('booking')}
            className="bg-[#1B78D4] hover:bg-[#1464BB] text-white font-bold text-sm px-5 py-3 rounded-xl cursor-pointer whitespace-nowrap transition-colors"
          >
            Book Free Inspection
          </button>
        </div>
      )}
    </nav>
  );
}
